// CUSTOM ICON COMPONENT
import duotone from '@/icons/duotone';

export const navigation = [
  {
    name: 'Dashboard',
    Icon: duotone.Dashboard,
    path: '/dashboard'
  },
  {
    name: 'Matches',
    Icon: duotone.Calender,
    path: '/matches'
  },
  {
    name: 'Players',
    Icon: duotone.UserList,
    path: '/players'
  },
  {
    name: 'Media Library',
    Icon: duotone.Folder,
    path: '/media'
  },
  {
    name: 'Social Connections',
    Icon: duotone.Send,
    path: '/social-connections'
  },
  {
    name: 'Teams',
    Icon: duotone.LayerGroup,
    path: '/teams',
    requiresClubAdmin: true,
    position: 'bottom'
  },
  {
    name: 'Content Templates',
    Icon: duotone.DataTable,
    path: '/content-templates',
    requiresClubAdmin: true,
    position: 'bottom'
  },
  {
    name: 'Club Settings',
    Icon: duotone.Settings,
    path: '/club-settings',
    requiresClubAdmin: true,
    position: 'bottom'
  }
];